// guards/role.guard.ts
import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router
} from '@angular/router';
import { UserStore } from '../user/store/user.store';
import { NectaUserRole } from '../user/models/user';

export const RoleGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot
) => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  const requiredRoles = route.data['roles'] as NectaUserRole[] ?? [];

  if (!userStore.hasAnyRole(requiredRoles)) {
    router.navigate(['/unauthorized']);
    return false;
  }

  return true;

};